// LIBRERIE/IMPORTS
import { useTranslation } from "react-i18next";
import Carousel from 'react-bootstrap/Carousel';
import { useState, useEffect } from "react";

// HOOKS
import { useGetAgencyDetails } from "../../../hooks/useGetAgencyDetails";

// CONFIGURAZIONI
import { AGENCY_ID } from "../../../config/appConfig";

// COMPONENTI
import LoadingIndicator from "../../Loaders/LoadingIndicator";
import SlowLoadComponent from "../../Error/SlowLoadComponent";
import PropertySearchField from "../../Home/Search";
import NotFound from "../../Error/NotFound";

interface SubHeaderHomeProps {
    agencyName?: string;
    isSeo: boolean;
    showSearchForm?: boolean;
}

const SubHeaderHome: React.FC<SubHeaderHomeProps> = ({
    showSearchForm = true // Default a true se non specificato
}) => {

    const { agency, loading, error } = useGetAgencyDetails(AGENCY_ID);
    const { t } = useTranslation();

    const carouselImages = [
        {
            path: "assets/images/inHome/heroCarousel/1.jpg",
            altImg: t('homePage.hero.carouselAlt1')
        },
        {
            path: "assets/images/inHome/heroCarousel/2.jpg",
            altImg: t('homePage.hero.carouselAlt2')
        },
        {
            path: "assets/images/inHome/heroCarousel/3.jpg",
            altImg: t('homePage.hero.carouselAlt3')
        }
    ]

    // Transizione per rendere visibile la ricerca
    const [boxVisible, setBoxVisible] = useState(false);

    useEffect(() => {
        const handleVisible = () => {
        setBoxVisible(true)
        };
        
        const timer = setTimeout( handleVisible, 2000);
        return () => clearTimeout(timer);
    },[])

    // Rendering Componente
    if (loading) return <LoadingIndicator />;
    if (error) return <SlowLoadComponent />;
    if (!agency) return <NotFound message={`${t('common.agencyNotFound')}`} />;

    return (
        <section className="banner bg-overlay-black-20">
            <Carousel fade controls={false} interval={5000}>
                {carouselImages.map((image, index) => (
                    <Carousel.Item key={index} >
                        <img src={image.path} alt={image.altImg} />
                    </Carousel.Item>
                ))}
            </Carousel>
            <div className={`text-wrapper ${boxVisible ? 'visible' : ''}`}>
                <h2 dangerouslySetInnerHTML={{ __html: t('homePage.hero.title') as string }} />
                {showSearchForm && <PropertySearchField searchData={{}} />}
            </div>
        </section>
    );
};

export default SubHeaderHome;